// Company feature flags (ASA-225). Keys are fixed and mirror the backend
// (App\Enum\Feature). A feature is enabled unless the effective map explicitly
// disables it; always-on features can never be disabled.

const FEATURE = {
    QUICK_OVERVIEW: "quick_overview",
    REPORTS: "reports",
    VISIT_PREDICTION: "visit_prediction",
    LOCATION_PERFORMANCE: "location_performance",
    LOCATION_COMPARISON: "location_comparison",
    MAILING_REPORTS: "mailing_reports",
    REGION_MANAGEMENT: "region_management",
    LOCATION_MANAGEMENT: "location_management",
    WORKING_TIME_MANAGEMENT: "working_time_management",
} as const

// Editable toggles, in the order shown in the Edit Company mockup.
export const EDITABLE_FEATURES: string[] = [
    FEATURE.QUICK_OVERVIEW,
    FEATURE.REPORTS,
    FEATURE.VISIT_PREDICTION,
    FEATURE.LOCATION_PERFORMANCE,
    FEATURE.LOCATION_COMPARISON,
    FEATURE.MAILING_REPORTS,
]

// Always-on features: rendered as ON + disabled, never hidden.
export const ALWAYS_ON_FEATURES: string[] = [
    FEATURE.REGION_MANAGEMENT,
    FEATURE.LOCATION_MANAGEMENT,
    FEATURE.WORKING_TIME_MANAGEMENT,
]

// feature key -> translation key (human readable name).
export const FEATURE_LABELS: Record<string, string> = {
    [FEATURE.QUICK_OVERVIEW]: "featureFlags.quickOverview",
    [FEATURE.REPORTS]: "featureFlags.reports",
    [FEATURE.VISIT_PREDICTION]: "featureFlags.visitPrediction",
    [FEATURE.LOCATION_PERFORMANCE]: "featureFlags.locationPerformance",
    [FEATURE.LOCATION_COMPARISON]: "featureFlags.locationComparison",
    [FEATURE.MAILING_REPORTS]: "featureFlags.mailingReports",
    [FEATURE.REGION_MANAGEMENT]: "featureFlags.regionManagement",
    [FEATURE.LOCATION_MANAGEMENT]: "featureFlags.locationManagement",
    [FEATURE.WORKING_TIME_MANAGEMENT]: "featureFlags.workingTimeManagement",
}

export default FEATURE
